import apiClient from '../axios';

export default {

    getCursosMatriculadosPorUsuario(id) {
        return apiClient.get(`/matriculas/usuario/${id}`);
    },

};